import styled from '@emotion/styled';
import { Modal as AModal } from 'antd';
import bg from './assets/bg.png';

export interface NiceMessageDialogProps {
  visible: boolean;
  title: string;
  content: string;
  width?: number;
  footer?: React.ReactNode;
  onCancel?: () => void;
}

export const NiceMessageDialog = (props: NiceMessageDialogProps) => {
  const { width = 340, visible, title, content, footer, onCancel } = props;

  return (
    <Modal
      width={width}
      visible={visible}
      title={null}
      footer={null}
      bodyStyle={{ padding: 0 }}
      closable={false}
      centered
      className="!-top-32"
      destroyOnClose
      onCancel={onCancel}
      maskClosable={false}
    >
      <Wrapper className="pt-32 pb-8 flex flex-col items-center" style={{ width }}>
        <p className="text-[#1A3484] font-medium text-base">{title}</p>
        <p className="w-3/4 text-sm text-[#232426]">{content}</p>
        {footer}
      </Wrapper>
    </Modal>
  );
};

const Modal = styled(AModal)`
  .ant-modal-content {
    background-color: transparent;
    box-shadow: none;
  }
`;
const Wrapper = styled.div`
  background-image: url(${bg});
  background-size: 100% 100%;
`;
